import { render, staticRenderFns } from "./InventoryBalancePerSegmentsChart.vue?vue&type=template&id=62b21935&scoped=true"
import script from "./InventoryBalancePerSegmentsChart.vue?vue&type=script&lang=js"
export * from "./InventoryBalancePerSegmentsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b21935",
  null
  
)

export default component.exports